// @ts-check
/** @typedef {{exportTemplate: import('../state').ExportTemplateState}} RootState */
import { createSelector } from 'reselect';

/**
 * @param {RootState} state */
export const getSheetMetadata = state => state.exportTemplate.sheetMetadata;

/**
 * @param {RootState} state */
export const doesSheetMetadataExist = state =>
  state.exportTemplate.sheetMetadata !== null &&
  state.exportTemplate.sheetMetadata.length > 0;

/**
 * @param {RootState} state
 * @param {string} sheetMetadataId
 * @returns {string}
 */
export const getSheetDefaultName = createSelector(
  [getSheetMetadata, (_, sheetMetadataId) => sheetMetadataId],
  (metadata, sheetMetadataId) => {
    for (const sheet of metadata) {
      if (sheet.id === sheetMetadataId) {
        return sheet.name;
      }
    }
    return '';
  },
  {
    memoizeOptions: {
      maxSize: 50,
    },
  }
);

/**
 * @param {RootState} state
 * @returns {number}
 */
export const countMetadataSheets = state => {
  return state.exportTemplate.sheetMetadata.length;
};

/**
 * @param {RootState} state
 * @returns {number}
 */
export const countMetadataColumns = state => {
  let count = 0;
  for (const sheet of state.exportTemplate.sheetMetadata) {
    count += sheet.columns.length;
  }
  return count;
};
